import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { H5 } from '../../atoms';
import { DropdownMenu } from '../DropdownMenu';

const StyledDropdownMenu = styled(DropdownMenu)`
  width: max-content;
`;

const StyledH5 = styled(H5)`
  padding: 8px;
`;

const ColumnMentionsDropdownMenu = forwardRef(
  ({ children, referenceElement = null, hideHeader = false, ...props }, ref) => (
    <StyledDropdownMenu
      ref={ref}
      referenceElement={referenceElement}
      {...props}
      menuPlacement='bottom-start'
    >
      {!hideHeader && <StyledH5 color='var(--content-subtitle)'>Column names</StyledH5>}
      {children}
    </StyledDropdownMenu>
  )
);

// lexical-beautiful-mentions specific props
ColumnMentionsDropdownMenu.propTypes = {
  'aria-activedescendant': PropTypes.string.isRequired,
  'aria-hidden': PropTypes.bool.isRequired,
  'aria-label': PropTypes.string.isRequired,
  // mention dropdown item props
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  loading: PropTypes.bool.isRequired,
  role: PropTypes.string.isRequired,
  referenceElement: PropTypes.instanceOf(Element),
  hideHeader: PropTypes.bool
};
export { ColumnMentionsDropdownMenu };
